import { GET } from '../../services/rest.service';

export const GET_ALL = 'GET_ALL';
export const RESET = 'CLEAR';
export const ERROR = 'ERROR';

export const getAllSkills = () => {
  return async (dispatch) => {
    try {
      const res = await GET('/general/skill/getAll');
      dispatch({
        type: GET_ALL,
        payload: res.data,
      });
    } catch (err) {
      dispatch({
        type: ERROR,
        payload: [],
      });
    }
  };
};
